export default __webpack_public_path__ + "media/zurb/img/work/paysa-thumb-a1d1734655ad3a3c457222e42b4694e5.png";